import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WDialog from "@/components/wrappers/w-dialog.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
let WPdfViewerDialog = class WPdfViewerDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "pdfUrl", void 0);
    _defineProperty(this, "title", void 0);
  }
  /**
   * Builds the URL pointing to the bundled PDF.js viewer with the requested file passed as query param.
   * Mirrors the legacy {@code pdfFullScreen.html} tag.
   */
  get viewerUrl() {
    if (!this.pdfUrl) return '';
    const fileParam = this.pdfUrl.startsWith('http') ? this.pdfUrl : this.pdfUrl.startsWith('/') ? this.pdfUrl : '/' + this.pdfUrl;
    return '/public/javascripts/pdfJS/generic/web/viewer.html?file=' + encodeURIComponent(fileParam);
  }
  onClose() {
    this.$emit('close');
  }
};
__decorate([Prop({
  required: true
})], WPdfViewerDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], WPdfViewerDialog.prototype, "pdfUrl", void 0);
__decorate([Prop({
  default: ''
})], WPdfViewerDialog.prototype, "title", void 0);
WPdfViewerDialog = __decorate([Component({
  components: {
    WDialog,
    StandardButton
  },
  emits: ["close"]
})], WPdfViewerDialog);
export default WPdfViewerDialog;